import React, { useEffect, useState } from 'react';
import AppLayout from '../../../../components/layout/AppLayout';
import { message } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { TLesson } from '../../../../models/courses/lesson';
import { useCourseApi } from '../../../../api/courses/courses';
import LessonBlocklyPhaserAdmin from '../../../../components/BlocklyPhaser/root/admin/LessonBlocklyPhaserAdmin';

const LessonBlocklyPhaser: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { getLessonDetailsById } = useCourseApi();

    const lesson: TLesson = location.state?.lesson;
    const teacherMode: boolean = location.state?.teacherMode || false;
    const [editingLesson, setEditingLesson] = useState<TLesson | undefined>(lesson);
    const [loading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        setIsLoading(true);

        if (lesson) {
            getLessonDetailsById(lesson.id)
                .then((results) => {
                    const lessonData = results;
                    setEditingLesson(lessonData.data);
                })
                .catch((err) => {
                    message.error(err.response?.data ?? err.message);
                })
                .finally(() => {
                    setIsLoading(false);
                });
        } else {
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [lesson]);

    const handleBackNavigation = () => {
        navigate(-1);
    };

    return (
        <AppLayout 
            title={lesson?.name || ''} 
            loading={loading}
            onBackNavigation={handleBackNavigation}
            showBackButton={true}
        >
            <LessonBlocklyPhaserAdmin lesson={editingLesson} teacherMode={teacherMode} />
        </AppLayout>
    );
};

export default LessonBlocklyPhaser;
